import { create } from 'zustand';
import { ICreator } from '~/types';

type UseEditCreatorStore = {
  closeEditModal: () => void;
  closeFiltersDrawer: () => void;

  isEditDrawerOpen: boolean;
  openEditDrawer: (creator: ICreator) => void;
  closeEditDrawer: () => void;

  isEditModalOpen: boolean;
  isFiltersDrawerOpen: boolean;
  openEditModal: (creator: ICreator) => void;
  openFiltersDrawer: () => void;
  selectedCreator: undefined | ICreator;
  updatedSelectedCreator: (creator: ICreator) => void;
};

export const useEditCreatorStore = create<UseEditCreatorStore>((set) => ({
  closeEditModal: () =>
    set(() => ({ isEditModalOpen: false, selectedCreator: undefined })),
  closeFiltersDrawer: () => set(() => ({ isFiltersDrawerOpen: false })),

  isEditDrawerOpen: false,
  openEditDrawer: (creator) =>
    set(() => ({ isEditDrawerOpen: true, selectedCreator: creator })),
  closeEditDrawer: () =>
    set(() => ({ isEditDrawerOpen: false, selectedCreator: undefined })),

  isEditModalOpen: false,
  isFiltersDrawerOpen: false,
  openEditModal: (creator) =>
    set(() => ({ isEditModalOpen: true, selectedCreator: creator })),
  openFiltersDrawer: () => set(() => ({ isFiltersDrawerOpen: true })),
  selectedCreator: undefined,
  updatedSelectedCreator: (creator) =>
    set(() => ({ selectedCreator: creator })),
}));
